import { Provider } from "./provider/Provider";

const IstatistiklerService = {
  getStats: ({ stats, is, browser, platform, valid, start, limit, order }) => {
    return Provider({
      stats,
      is,
      browser,
      platform,
      valid,
      start,
      limit,
      order,
      methodName: "Module/Istatistikler/GetStats",
    });
  },
  getStatsCount: ({ stats, is, browser, platform, valid }) => {
    return Provider({
      stats,
      is,
      browser,
      platform,
      valid,
      methodName: "Module/Istatistikler/GetStatsCount",
    });
  },
  getStatsList: ({
    stats,
    is,
    browser,
    platform,
    valid,
    start,
    limit,
    order,
  }) => {
    return Provider({
      stats,
      is,
      browser,
      platform,
      valid,
      start,
      limit,
      order,
      methodName: "Module/Istatistikler/GetStatsList",
    });
  },
  getStatsAll: ({ stats, is, browser, platform, valid }) => {
    return Provider({
      stats,
      is,
      browser,
      platform,
      valid,
      methodName: "Module/Istatistikler/GetStatsAll",
    });
  },
  getBrowserStats: ({ stats }) => {
    return Provider({
      stats,
      methodName: "Module/Istatistikler/GetBrowserStats",
    });
  },
  getModuleStats: ({ moduleName, statsName, stats, start, limit, order }) => {
    return Provider({
      moduleName,
      statsName,
      stats,
      start,
      limit,
      order,
      methodName: "Module/Istatistikler/GetModuleStats",
    });
  },
  getModuleStatsCount: ({ moduleName, statsName, stats }) => {
    return Provider({
      moduleName,
      statsName,
      stats,
      methodName: "Module/Istatistikler/GetModuleStatsCount",
    });
  },
};

export default IstatistiklerService;
